import ArrayTabs from '.';

/** @type {UICore.Layout} */
const defaultArrayItem = {
  type: 'w-tab-pane',
  props: {
    title: '第 {{ data.num }} 项'
  },
  children: [{
    type: 'w-text',
    props: {
      text: '请编辑页卡内容'
    }
  }]
};

/** @type {UICore.ComponentMeta} */
const ArrayTabsComponentMeta = {
  id: 'w-array-tabs',
  name: 'Tab卡列表',
  visible: false,
  isFormEditor: true,
  component: ArrayTabs,
  slots: [{
    id: 'item',
    type: 'scoped',
    default: {
      layout: defaultArrayItem
    }
  }, {
    id: 'empty',
    containerRef: 'empty'
  }],
  bindings: [{
    id: '数据源',
    pathProp: 'path',
    required: true,
    main: true,
    checkData: s => s.type === 'array'
  }],
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'path',
      type: 'string',
      title: '数据源',
      readonly: true,
      description: '请通过“连连看”的方式添加绑定'
    }, {
      id: 'pageletId',
      type: 'string',
      title: '对应页面片',
      hidden: true
    }, {
      id: 'readonly',
      type: 'boolean',
      title: '只读模式',
      default: false
    }, {
      id: 'allowAdd',
      type: 'boolean',
      title: '允许新增'
    }, {
      id: 'allowDelete',
      type: 'boolean',
      title: '允许删除'
    }, {
      id: 'allowSort',
      type: 'boolean',
      title: '允许拖拽页卡，调整顺序'
    }, {
      id: 'keyingRule',
      title: '列表项的key',
      description: '相当于 v-for 里的 key 的计算方式',
      type: 'any',
      group: '高级配置',
      ui: {
        type: 'listKeyingRuleInput'
      }
    }]
  },
  events: [{
    id: 'delete',
    name: '删除单条',
    desc: '删除单条前触发，可通过 终止流程 的方式阻止删除',
    asProp: 'onDelete'
  }],
  getLayoutName() {
    return 'Tab卡列表';
  },
  getActions({
    instance
  }) {
    return [{
      title: '编辑“没有内容”状态',
      icon: 'fa fa-edit',
      highlighted: !!(instance !== null && instance !== void 0 && instance.emulateEmptyMode),
      execute() {
        // eslint-disable-next-line no-param-reassign
        instance.emulateEmptyMode = !instance.emulateEmptyMode;
      }
    }];
  }
};
export default ArrayTabsComponentMeta;